// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__ZP2pX","col":"styles_col__FR6yR"};